/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ClientMessageTypeEnum = 'Default' | 'Private' | 'Urgent' | 'All';

export const ClientMessageTypeEnum = {
    Default: 'Default' as ClientMessageTypeEnum,
    Private: 'Private' as ClientMessageTypeEnum,
    Urgent: 'Urgent' as ClientMessageTypeEnum,
    All: 'All' as ClientMessageTypeEnum
};

